import { AuthLayout } from '../AuthLayout/AuthLayout';

export const SignInPage = ({ children }: { children: React.ReactNode }) => (
  <AuthLayout
    title="Simplified recyclables trading"
    subtitle="Sign into Safi with your work email or phone number. We'll send you a one-time passcode for faster access."
  >
    {children}
  </AuthLayout>
);
